import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import Hint from '../../components/Hint/Hint';
import SingleSelect from '../../components/SingleSelect/SingleSelect';
import { useMenu } from '../../contexts/MenuContext';
import InfoBox from '../../components/InfoBox/InfoBox';
import withForm from '../../layouts/withForm';

const Advanced = ({handleChange}) => {
    const {
        settingData
    } = useMenu();

    return (
        <>
            
            {/* <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Delete passkey challenge records older than", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Delete passkey challenge records older than", "ultimate-security")}/>                                    
                                    <SingleSelect
                                        options={[
                                            {label: 'Never', value: 'never'},
                                            {label: 'Older than 30 days', value: '30'},
                                            {label: 'Older than 60 days', value: '60'},
                                            {label: 'Older than 90 days', value: '90'},
                                            {label: 'Older than 180 days', value: '180'},
                                            {label: 'Older than 365 days', value: '365'},
                                        ]}
                                        initialValue={settingData?.security?.passkeys?.advanced_settings?.delete_passkeys_challenge_records_older_than || 'never'}
                                        name="security.passkeys.advanced_settings.delete_passkeys_challenge_records_older_than"
                                        selected={settingData?.security?.passkeys?.advanced_settings?.delete_passkeys_challenge_records_older_than}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("Automatically removes outdated passkey challenge records to optimize database performance. If set to \"Never\", records will not be deleted.", "ultimate-security")}</p>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Delete log records older than", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint position="top" content={__("Choose Login User Verification", "ultimate-security")}/>                                    
                                    <SingleSelect
                                        options={[
                                            {label: 'Never', value: 'never'},
                                            {label: 'Older than 30 days', value: '30'},
                                            {label: 'Older than 60 days', value: '60'},
                                            {label: 'Older than 90 days', value: '90'},
                                            {label: 'Older than 180 days', value: '180'},
                                            {label: 'Older than 365 days', value: '365'},
                                        ]}
                                        initialValue={settingData?.security?.passkeys?.advanced_settings?.delete_log_records_older_than || 'never'}
                                        name="security.passkeys.advanced_settings.delete_log_records_older_than"
                                        selected={settingData?.security?.cloudflare_turnstile?.delete_log_records_older_than}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="title-group" style={{marginLeft: '30px',marginTop:"10px"}}>
                                    <p className="pl-body text-text">{__("(Not recommended) Automatically deletes outdated log records. If set to \"Never\", logs will not be removed. This results in the loss of activity log history.", "ultimate-security")}</p>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <InfoBox className="big-infobox" title={__("Configuring Cron Jobs", "ultimate-security")} content={__("To ensure these options work as expected, it is recommended to set up a cron job on your server. A cron job is a scheduled task that automatically runs at specified intervals. Here’s how you can set up a cron job: Log in to your web server control panel, such as cPanel or Plesk.Find the option to manage cron jobs and select it.In the “Add New Cron Job” section, specify the frequency at which you want the cron job to run, for example, every hour or every day.In the “Command” field, enter the following command:wget -q -O - https://playground.wpultimatesecurity.com/wp-cron.php?doing_wp_cron Save the cron job.Add the following code to your \"wp-config.php\" file:define('DISABLE_WP_CRON', true); ", "ultimate-security")} />
            </div>

        </>
    )
}
export default withForm(Advanced,'security.passkeys.advanced_settings');